import { Host, h } from '@stencil/core';
export class AibaMikMak {
  constructor() {
    this.handlers = undefined;
    this.product = undefined;
    this.smartProductId = undefined;
    this.label = undefined;
    this.modifiers = [];
    this.appId = undefined;
  }
  initializeSwnDataLayer(e, d) {
    try {
      // let a = ((window as any).swnDataLayer = (window as any).swnDataLayer || {});
      // a.appId = e || a.appId;
      // a.eventBuffer = a.eventBuffer || [];
      // a.loadBuffer = a.loadBuffer || [];
      // a.push =
      //   a.push ||
      //   function (e) {
      //     a.eventBuffer.push(e);
      //   };
      // a.load =
      //   a.load ||
      //   function (e) {
      //     a.loadBuffer.push(e);
      //   };
      // a.dnt = a.dnt !== null ? a.dnt : d;
      // // Check if the script already exists using querySelector
      // let scriptSrc = '//wtb-tag.mikmak.ai/scripts/' + a.appId + '/tag.min.js';
      // let existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
      // // If the script does not exist, append it
      // if (!existingScript) {
      //   let t = document.getElementsByTagName('script')[0],
      //     n = document.createElement('script');
      //   n.async = true;
      //   n.src = scriptSrc;
      //   t.parentNode.insertBefore(n, t);
      // }
      if (!document.getElementById('mikmak-aiba')) {
        console.info('mikmak loaded: ', window.swnTagLoaded);
        if (window.swnTagLoaded) {
          window.swnTagLoaded = 0;
        }
        const script = document.createElement('script');
        script.async = true;
        script.id = 'mikmak-aiba';
        script.innerHTML = `
        (function(e,d){
          try{
            var a=window.swnDataLayer=window.swnDataLayer||{};
            a.appId=e||a.appId,a.eventBuffer=a.eventBuffer||[],a.loadBuffer=a.loadBuffer||[],
            a.push=a.push||function(e){a.eventBuffer.push(e)},
            a.load=a.load||function(e){a.loadBuffer.push(e)},
            a.dnt=a.dnt!=null?a.dnt:d;
            var t=document.getElementsByTagName("script")[0],
            n=document.createElement("script");
            n.async=!0,n.src="//wtb-tag.mikmak.ai/scripts/"+a.appId+"/tag.min.js",
            t.parentNode.insertBefore(n,t)
          } catch(e){
            console.log(e)
          }
        })("` + e + `", ` + d + `);
      `;
        const body = document.body;
        body.insertBefore(script, body.firstChild);
      }
    }
    catch (e) {
      console.log('Error: ', e);
    }
  }
  loadButton() {
    const button = document.createElement('button');
    button.className = 'us-c-add-to-basket__display-button c-button swn-tag-wtb-btn ';
    button.dataset.eans = `${this.smartProductId}`;
    button.dataset.id = `${this.smartProductId}`;
    button.dataset.label = this.label;
    button.id = `aiba-mik-mak-${this.smartProductId}`;
    // button.dataset.analyticsEvent38 = 'data-analytics-event38';
    button.setAttribute('aria-label', this.label);
    button.textContent = this.label;
    button.style.display = 'none';
    document.querySelector('body').appendChild(button);
  }
  async componentDidLoad() {
    await this.loadButton();
    this.initializeSwnDataLayer(this.appId, false);
  }
  async componentWillRender() {
    if (this.handlers && this.handlers.handleRecommendedProductsRender) {
      const reRender = await this.handlers.handleRecommendedProductsRender();
      if (reRender) {
        await this.loadButton();
        this.initializeSwnDataLayer(this.appId, false);
      }
    }
  }
  clickButton(smartProductId, event) {
    var _a;
    this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.handleMikMaKBuyNowClick(this.product, event));
    const button = document.getElementById(`aiba-mik-mak-${smartProductId}`);
    button === null || button === void 0 ? void 0 : button.click();
  }
  render() {
    return (h(Host, null, h("aiba-button", { value: this.label, handleClick: event => this.clickButton(`${this.smartProductId}`, event) })));
  }
  static get is() { return "aiba-mik-mak"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-mik-mak.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-mik-mak.css"]
    };
  }
  static get properties() {
    return {
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "product": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product",
        "reflect": false
      },
      "smartProductId": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "string | number",
          "resolved": "number | string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "smart-product-id",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label",
        "reflect": false
      },
      "modifiers": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "[]"
      },
      "appId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "app-id",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-mik-mak.js.map
